// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"9a06c14f","878":"b4ebd04a"}[chunkId] + ".chunk.js";
};